import React from 'react';
import { Box, Heading } from '@wix/design-system';
import { ExactMatchHeadlineSkeleton } from './ExactMatchHeadlineSkeleton';
import { exactMatchHeadlineApiClient } from './ExactMatchHeadline.apiClient';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import s from './ExactMatchHeadline.css';
export const ExactMatchHeadline = _ref => {
  let {
    domain,
    dataHook = 'exact-match-headline'
  } = _ref;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const {
    data,
    isLoading
  } = exactMatchHeadlineApiClient.hooks.useExactMatchHeadline({
    domain
  }, true, {
    staleTime: Infinity,
    cacheTime: Infinity,
    useErrorBoundary: false
  });
  const headline = (data == null ? void 0 : data.description) || (data == null ? void 0 : data.fallbackTitleKey) && t(data.fallbackTitleKey, {
    domainName: domain
  });
  if (isLoading) {
    return /*#__PURE__*/React.createElement(ExactMatchHeadlineSkeleton, {
      dataHook: `${dataHook}-skeleton`
    });
  }
  if (!headline) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    padding: "20px 0 24px 0",
    align: "center",
    textAlign: "center",
    dataHook: dataHook
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "medium",
    as: "h2",
    className: s.headline
  }, headline));
};
//# sourceMappingURL=ExactMatchHeadline.js.map